module.exports = __webpack_public_path__ + "img/cupcake_20x20.d53dc14c.svg";